
const AccessDenied: React.FC = () => {
    return (
        
        <div className="d-flex justify-content-center align-items-center vh-100">
        <h2 className="lh-1-5 mt-6">
          Looks like you do not have access. Please reach out to Joshua Ellison to get set up.
        </h2>
        </div>
      
    );
};
    export default AccessDenied;